module.exports = __webpack_public_path__ + "img/IB.9e3e653b.png";